import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=6679aaca&scoped=true&"
import script from "./changeEmail.vue?vue&type=script&lang=js&"
export * from "./changeEmail.vue?vue&type=script&lang=js&"
import style0 from "./changeEmail.vue?vue&type=style&index=0&id=6679aaca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679aaca",
  null
  
)

export default component.exports